// extracted by mini-css-extract-plugin
export default {"brandPromo":"TG-z","carousel":"UG-z"};